<template lang="pug">
#customize
  .container.custom_container_lg
    .row
      .col-12
        .html_content(v-html="pageData.HtmlContent")
  custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import { getCustomizePage } from "@/json/customize";

export default {
  name: "Customize",
  metaInfo() {
    return {
      title: this.pageData.SEO_Title,
      meta: [{ name: "description", content: this.pageData.SEO_Description }],
    };
  },
  components: {
    "custom-footer": CustomFooter,
  },
  data() {
    return {
      pageData: {},
    };
  },
  created() {
    this.initPage(this.$route.params.page);
  },
  methods: {
    initPage(JSON_NAME) {
      getCustomizePage(JSON_NAME).then((response) => {
        this.pageData = response.data;
      });
    },
  },
};
</script>
